import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Skeleton,
  Typography,
} from '@mui/material';

import CustomCard from 'components/shared/CustomCard/CustomCard';
import CustomModal from 'components/shared/CustomModal/CustomModal';
import { ModalAction } from 'model/modal.model';
import { Dispatch, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import RoutePaths from 'routes/RoutePaths';
import { DealsService } from 'service/deals.service';
import zeplinColor from 'theme/Color';

export const DealSelectionModal = ({
  isModalOpen,
  modalDispatch,
}: {
  isModalOpen: boolean;
  modalDispatch: Dispatch<ModalAction>;
}) => {
  const [loading, setLoading] = useState(false);
  const [dealTypes, setDealTypes] = useState({});
  const [dealTypeSelected, setDealTypeSelected] = useState('');

  const handleTaskType = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDealTypeSelected(event.target.value);
  };

  useEffect(() => {
    const fetchDealTypes = async () => {
      try {
        setLoading(true);
        const response = await DealsService.getDealTypes();
        setDealTypes(response);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchDealTypes();
  }, []);

  return (
    <CustomModal
      handleClose={() => modalDispatch({ type: 'CLOSE', payload: 'typeSelect' })}
      open={isModalOpen}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: '24px',
            backgroundColor: zeplinColor.Neutral1,
            width: { xs: '280px', xl: '312px' },
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: '18px', xl: '24px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                }}
              >
                <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                  Select Deal Type
                </Typography>
              </Box>
              <img
                src={'/assets/cross.svg'}
                alt='logo'
                onClick={() => modalDispatch({ type: 'CLOSE', payload: 'typeSelect' })}
                style={{ cursor: 'pointer' }}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '10px', xl: '16px' },
              }}
            >
              <RadioGroup
                aria-labelledby='demo-controlled-radio-buttons-group'
                name='controlled-radio-buttons-group'
                value={dealTypeSelected}
                onChange={handleTaskType}
                sx={{
                  color: zeplinColor.BasicBlack,
                  '&.Mui-checked': {
                    color: zeplinColor.BasicBlack,
                  },
                  padding: '0px',
                }}
              >
                {loading ? (
                  <Skeleton
                    variant='text'
                    sx={{
                      width: '100%',
                    }}
                  />
                ) : (
                  Object.keys(dealTypes).map((name) => (
                    <FormControlLabel
                      key={name}
                      value={name}
                      control={
                        <Radio
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                      }
                      label={name}
                      sx={{
                        color: zeplinColor.BasicBlack,
                        '& .MuiButtonBase-root': {
                          color: zeplinColor.BasicBlack,
                        },
                        padding: '0px',
                      }}
                    />
                  ))
                )}
              </RadioGroup>
            </Box>

            <Button
              to={`${RoutePaths.Deals}/new`}
              state={{ type: dealTypeSelected }}
              component={Link}
              disabled={!dealTypeSelected}
              sx={{
                textDecoration: 'none',
                bgcolor: zeplinColor.Brand1,
                color: zeplinColor.Neutral1,
                borderRadius: '14px',
                height: '48px',
                '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                '&.Mui-disabled': {
                  bgcolor: zeplinColor.Neutral5,
                  color: zeplinColor.Neutral8,
                },
              }}
              disableRipple
              disableElevation
              disableFocusRipple
              disableTouchRipple
            >
              <Typography variant='buttonMedium'>Continue</Typography>
            </Button>
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};
